import { getPrimaryConfig, Configurable } from "@crystal/config";
import { getMfSiteConfig } from "./site-config.js";
const config = getPrimaryConfig();
const mfSiteConfig = getMfSiteConfig();
const consentsConfig = Configurable.props({
  sitePath: config.prop("sitePath"),
  locale: config.prop("locale"),
  isSelectAllEnabled: mfSiteConfig.prop("isSelectAllEnabled"),
  selectAllScenarios: mfSiteConfig.prop("selectAllScenarios")
});
export {
  consentsConfig
};
//# sourceMappingURL=config.js.map
